// admin-ui/src/routes/AuthCallback.jsx
import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabaseClient'

export default function AuthCallback() {
  const [status, setStatus] = useState('Verarbeite Login …')
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false

    async function run() {
      try {
        const url = new URL(window.location.href)
        const params = url.searchParams

        console.log(
          '[AuthCallback] URL:',
          window.location.href,
        )

        /*
         * Auth-Parameter erkennen.
         *
         * Je nach Supabase-Flow erhalten wir:
         * - code
         * - auth_code
         * - token_hash
         *
         * oder die Session wurde bereits von
         * supabase-js übernommen.
         */
        const code =
          params.get('code') ||
          params.get('auth_code')

        const tokenHash =
          params.get('token_hash')

        const type =
          params.get('type') ||
          'magiclink'

        let authError = null

        if (code) {
          setStatus(
            'Tausche Login-Code gegen Session …',
          )

          const { error } =
            await supabase.auth.exchangeCodeForSession(
              code,
            )

          authError = error
        } else if (tokenHash) {
          setStatus(
            'Verifiziere Magic Link …',
          )

          const { error } =
            await supabase.auth.verifyOtp({
              token_hash: tokenHash,
              type,
            })

          authError = error
        } else {
          /*
           * Möglicherweise wurde die Session bereits
           * automatisch von Supabase verarbeitet.
           */
          setStatus('Prüfe Session …')

          const {
            data,
            error,
          } = await supabase.auth.getSession()

          if (error) {
            authError = error
          }

          if (!data?.session) {
            authError =
              authError ||
              new Error(
                'Login-Link ist ungültig oder wurde bereits verwendet.',
              )
          }
        }

        if (authError) {
          throw authError
        }

        /*
         * Abschließender Session-Check.
         */
        const {
          data: { session },
          error: sessionError,
        } = await supabase.auth.getSession()

        if (sessionError) {
          throw sessionError
        }

        if (!session?.user?.id) {
          throw new Error(
            'Login abgeschlossen, aber keine gültige Session gefunden.',
          )
        }

        console.log(
          '[AuthCallback] Login erfolgreich:',
          session.user.email,
        )

        /*
         * Alte Return-To-Werte aus der bisherigen
         * Modul-C-Loginarchitektur entfernen.
         */
        try {
          localStorage.removeItem(
            'w2h:auth:returnTo',
          )

          localStorage.removeItem(
            'w2h:auth:done',
          )
        } catch (_) {
          // localStorage ist für den Login nicht kritisch.
        }

        if (cancelled) return

        setStatus(
          'Login erfolgreich. Admin-Bereich wird geladen …',
        )

        /*
         * WICHTIG:
         *
         * Immer zurück zur zentralen Startseite.
         *
         * Dort übernimmt AuthProvider:
         *
         * User
         * → profiles.role
         * → rollenbasiertes Menü
         */
        window.location.replace('/')
      } catch (e) {
        if (cancelled) return

        console.error(
          '[AuthCallback] Fehler:',
          e,
        )

        setError(
          e?.message ||
            'Login konnte nicht abgeschlossen werden.',
        )

        setStatus('Login fehlgeschlagen')
      }
    }

    run()

    return () => {
      cancelled = true
    }
  }, [])

  return (
    <main
      style={{
        maxWidth: 600,
        margin: '0 auto',
        padding: 20,
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <h2>W2H Login</h2>

      <p>{status}</p>

      {error && (
        <div
          style={{
            marginTop: 12,
            color: '#b91c1c',
          }}
        >
          <strong>Fehler:</strong>{' '}
          {error}

          <div
            style={{
              marginTop: 8,
              fontSize: 12,
              color: '#6b7280',
            }}
          >
            Bitte fordere bei Bedarf einen neuen
            Magic Link an. Ein Login-Link sollte nur
            einmal verwendet werden.
          </div>
        </div>
      )}
    </main>
  )
}